import collect from "./collect";

export default (itemId, sections) => {
  let column;

  const findItem = (item, index) => {
    if (item.id === itemId) {
      return true;
    }
  };

  collect(sections, (type, node) => {
    if (
      (type === "COLUMN" || type === "CELL") &&
      ((node.items && node.items.find(findItem)) || node.id === itemId)
    ) {
      column = node;
      return true;
    }
    return false;
  });

  return column;
};
